export enum REQUEST_BUNDLES_TYPE {
  QUOTE = 'QUOTE',
  ORDER = 'ORDER',
  CONTRACT = 'CONTRACT',
  RENEWAL_QUOTE = 'RENEWAL_QUOTE',
  RENEWAL_CONTRACT = 'RENEWAL_CONTRACT',
}
